export const TemplatesListContainer = () => {

    return (
        <div>

        </div>
    )
}
